// test773
(773 && 0);
